export const RESOURCE = 'membershipsearch';
export const ACTIONS = { Search: '/memberships', SearchSummary: '/membershipssummary' }